/**
* Content Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
import Player from '@vimeo/player/src/player';
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      contentAccordionOpen();

      function contentAccordionOpen() {
        if ( window.innerWidth < 769 ) {
          // DO NOT FIRE ANIMATIONS
          $( 'button.content-accordion__item-title' ).on( 'click', function() {
            // pause videos so that no videos play when accordion is closed
            const videos = document.getElementsByClassName( 'video' ); // This will get all iframes that are labeled manually by class "video" (YouTube videos)
            Array.prototype.forEach.call( videos, function( video ) {
              video.contentWindow.postMessage( JSON.stringify( {event: 'command', // Send command to YouTube to pause video.
                func: 'pauseVideo'} ), '*' );
            } );
            const vimeos = document.getElementsByClassName( 'vimeo' );
            Array.prototype.forEach.call( vimeos, function( video ) {
              const player = new Player( video ); // Vimeo API functions
              player.pause();
            } );
          } );
        } else {
          $( 'button.content-accordion__item-title' ).on( 'click', function() {
            // pause videos so that no videos play when accordion is closed
            const videos = document.getElementsByClassName( 'video' ); // This will get all iframes that are labeled manually by class "video" (YouTube videos)
            Array.prototype.forEach.call( videos, function( video ) {
              video.contentWindow.postMessage( JSON.stringify( {event: 'command', // Send command to YouTube to pause video.
                func: 'pauseVideo'} ), '*' );
            } );
            const vimeos = document.getElementsByClassName( 'vimeo' );
            Array.prototype.forEach.call( vimeos, function( video ) {
              const player = new Player( video ); // Vimeo API functions
              player.pause();
            } );
            if ( $( this ).hasClass( 'is-open' ) ) {
              $( 'button.content-accordion__item-title' ).each( function() {
                $( this ).next().outerHeight( 0 );
              } );
              const answerHeight = $( this ).next().find( '.answer-height' ).outerHeight();
              $( this ).next().outerHeight( answerHeight );
            } else {
              $( this ).next().outerHeight( 0 );
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
